import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';
import BackButton from '../components/common/BackButton';

const TYPE_ICONS = {
  comment:'💬', like:'❤️', follow:'👥', best_crop:'⭐',
  crop_ready:'', auto_close:'🔒', buyer_interest:'🛒', crop_request:'📦', request_accepted:'✅'
};

export default function NotificationsPage() {
  const navigate = useNavigate();
  const { notifications, markAllRead, clearAll } = useNotifications();

  React.useEffect(() => { markAllRead(); }, []);

  return (
    <div className="page">
      {/* ✅ Green header */}
      <div className="header header--simple">
        <BackButton />
        <div style={{ flex:1 }}>
          <div className="header__title">🔔 Notifications</div>
          <div className="header__subtitle">Activity on your crops</div>
        </div>
        {notifications.length > 0 && (
          <button className="header__action" onClick={clearAll}>Clear all</button>
        )}
      </div>

      <div className="container" style={{ paddingTop:'var(--sp-4)' }}>
        {notifications.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state__icon">🔔</div>
            <div className="empty-state__title">No notifications yet</div>
            <div className="empty-state__desc">Activity on your crops will appear here</div>
          </div>
        ) : (
          notifications.map((n, i) => (
            <div key={i} className="card" style={{ marginBottom:'var(--sp-2)', cursor: n.cropId ? 'pointer':'default', borderLeft:`4px solid var(--primary)` }}
              onClick={() => n.cropId && navigate(`/crop/${n.cropId}`)}>
              <div style={{ padding:'var(--sp-3) var(--sp-4)', display:'flex', alignItems:'flex-start', gap:'var(--sp-3)' }}>
                <div className="avatar avatar--sm" style={{ background:'var(--primary-light)', fontSize:18, flexShrink:0 }}>
                  {TYPE_ICONS[n.type] || '🔔'}
                </div>
                <div style={{ flex:1 }}>
                  <p className="text-sm text-dark" style={{ lineHeight:1.5 }}>{n.message}</p>
                  <p className="text-xs text-muted" style={{ marginTop:'var(--sp-1)' }}>
                    {n.createdAt ? new Date(n.createdAt).toLocaleTimeString('en-IN', { hour:'2-digit', minute:'2-digit' }) : 'Just now'}
                  </p>
                </div>
                {n.cropId && <span className="text-muted" style={{ fontSize:18 }}>›</span>}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
